import { render, staticRenderFns } from "./OtherStatementsForm.vue?vue&type=template&id=e4932a48&scoped=true"
import script from "./OtherStatementsForm.vue?vue&type=script&lang=js"
export * from "./OtherStatementsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4932a48",
  null
  
)

export default component.exports